const filterProductsAdsByProducts = props => {
  const { products, productsAds } = props

  return productsAds?.filter(({ product_sku: productSku }) =>
    products?.map(({ id }) => id).includes(Number(productSku))
  )
}

export default filterProductsAdsByProducts
